<div class="language-switcher" *ngIf="languages.length > 0">
    <ul class="m-0">
        <li
            class="nav-item"
            ngbDropdown
            placement="bottom-right"
            display="dynamic"
        >
            <button
                class="btn btn-outline-primary btn-sm"
                ngbDropdownToggle
                title="Select Language"
            >
                <img
                    [src]="
                        './assets/images/flags/' +
                        currentLanguage?.code +
                        '.png'
                    "
                    [alt]="currentLanguage?.name + ' flag'"
                />
            </button>
            <div class="dropdown-menu" ngbDropdownMenu>
                <button
                    *ngFor="let language of languages"
                    class="dropdown-item"
                    [class.active]="language.code === currentLanguage?.code"
                    (click)="onLanguageSelect(language)"
                >
                    <img
                        src="./assets/images/flags/{{ language.code }}.png"
                        [alt]="language.name + ' flag'"
                    />
                    {{ language.name }}
                </button>
            </div>
        </li>
    </ul>
</div>